import { LibraryItemType } from "./LibraryItemType";
import { LinkAssetType } from "./LinkAssetType";
import { AssetCategory, toAssetCategory } from "./AssetCategory";
import { AspectRatios } from "./AspectRatios";
import { Modify } from "../utilities/modifyType";
import { getLinkAssetType } from "./LinkAsset";

export interface LibraryItem {
    id: string;
    parentId?: string;
    type: LibraryItemType;
    name: string;
    linkUrl?: string;
    linkType?: LinkAssetType;
    isStarred: boolean;
    dateCreated: Date;
    dateModified: Date;
    dateAccessed: Date;
    datePreached?: Date;
    shareId?: string;
    isShared: boolean;
    isTemplate: boolean;
    templateDescription: string;
    scripture?: string;
    category?: AssetCategory;
    templateText?: string;
    slideExporterAspectRatio: AspectRatios;
    customSlideBackgroundImagePath?: string;
    shareViews?: number;
    shareUrl?: string;
    offlineMode?: boolean;
    locationPreached?: string
}

export type SerializedLibraryItem = Modify<LibraryItem,{
    dateCreated: string;
    dateModified: string;
    dateAccessed: string;
    datePreached?: string;
}>

export const deserializeLibraryItem = (libraryItem: SerializedLibraryItem): LibraryItem => {
	return {
		...libraryItem,
		linkType: getLinkAssetType(libraryItem.linkUrl),
		locationPreached: libraryItem.locationPreached,
		datePreached: libraryItem.datePreached ? new Date(libraryItem.datePreached) : undefined,
		dateAccessed: new Date(libraryItem.dateAccessed),
		dateCreated: new Date(libraryItem.dateCreated),
		dateModified: new Date(libraryItem.dateModified),
		category: libraryItem.category ? toAssetCategory(libraryItem.category) : undefined,
	};
};
